import React from 'react';
import Notification from '../../Shared/Notifications';
import { createCrane } from './services/cranes';
import { isValidEmail } from '../../Shared/functions';

class NewCrane extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            showNotification: false,
            disabledButton: false,
            name:'',
            identification:'',
            plate:'',
            phone:'',
            email:'',
            direction:'',
            idCrane:0,
        };
    }

    componentDidMount(){
        if(this.props.item) {
            const item = this.props.item; 
            this.setState({
                name:item.name,
                identification:item.identification,
                plate:item.numberPlate,
                phone:item.phone? item.phone[0] : '',
                email:item.email,
                direction:item.address,
                idCrane:item.id
            });
        }
    }


    endItemCreation = () => {
        if(this.checkValues()) {
            this.createCrane();
        }

    }

    createCrane = () => {
        createCrane({
            id:this.state.idCrane,
            identification:this.state.identification,
            numberPlate:this.state.plate,
            name:this.state.name,
            phone:[this.state.phone],
            email:String(this.state.email ?? '').trim().toLowerCase(),
            address:this.state.direction,
            active:true,
        }).then((result) => {
            if(result === undefined){
                return alert('La identificacion ya se encuentra en uso')
            }
            if(result && result.status === 200) {
                this.setState({showNotification: true, disabledButton: true});
                setTimeout(() => {
                    this.setState({showNotification: false, disabledButton: false});
                    this.props.closeDialog();
                }, 3000)
            }
        }).catch(error => console.log("el error", error))
    }

    checkValues = () => {
        if(!this.checkEmail(this.state.email)) {
            alert('El correo debe de tener un formato valido')
            return;
        }
        if(this.state.plate !== '' 
            && this.state.identification !== '' 
            && this.state.name !== '' 
            && this.state.phone !== '') {
                return true;
            }else{
                alert('Todos los campos deben ser obligatorios')
                return false;
            }
    }

    checkEmail = (email) => isValidEmail(email);

    renderNotification = () => {
        return(
            <Notification 
                show={this.state.showNotification}
                title={'Datos almacenados'}
                subtitle={'Sus datos fueron almacenados correctamente.'}
            />
        )
    }

    render() {
        return(
            <div className='space-y-12'>
                <div className="border-b border-gray-900/10 pb-12">
                    <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-4">
                        <div className="sm:col-span-4">
                            <p className="mt-1 text-sm/6 text-gray-600">
                                Esta informacion es completamente confidencial, asegurese de ingresar los datos correctamente.
                            </p>
                            <label htmlFor='roleName' className="text-base/7 font-semibold text-gray-900">
                                Nombre  
                            </label>
                            <div className="mt-2">
                                <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                        <input
                                            value={this.state.name}
                                            onChange={(e) => {this.setState({name:e.target.value})}}
                                            id="roleName"
                                            name="roleName"
                                            type="text"
                                            placeholder=""
                                            autoComplete=""
                                            className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm/6"
                                        />
                                </div>
                            </div>
                            <label htmlFor='roleName' className="text-base/7 font-semibold text-gray-900">
                                Identificacion 
                            </label>
                            <div className="mt-2">
                                <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                        <input
                                            value={this.state.identification}
                                            onChange={(e) => {if(isNaN(e.target.value)){return}else{this.setState({identification:e.target.value})}}}
                                            id="roleName"
                                            name="roleName"
                                            type="text"
                                            placeholder=""
                                            autoComplete=""
                                            className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm/6"
                                        />
                                </div>
                            </div>
                            <label htmlFor='roleName' className="text-base/7 font-semibold text-gray-900">
                                Placa 
                            </label>
                            <div className="mt-2">
                                <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                        <input
                                            value={this.state.plate}
                                            onChange={(e) => {this.setState({plate:e.target.value})}}
                                            id="roleName"
                                            name="roleName"
                                            type="text"
                                            placeholder=""
                                            autoComplete=""
                                            className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm/6"
                                        />
                                </div>
                            </div>
                            <label htmlFor='roleName' className="text-base/7 font-semibold text-gray-900">
                                Correo 
                            </label>
                            <div className="mt-2">
                                <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                        <input
                                            value={this.state.email}
                                            onChange={(e) => {this.setState({email:e.target.value})}}
                                            id="roleName"
                                            name="roleName"
                                            type="text"
                                            placeholder=""
                                            autoComplete=""
                                            className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm/6"
                                        />
                                </div>
                            </div>
                            <label htmlFor='roleName' className="text-base/7 font-semibold text-gray-900">
                                Telefono 
                            </label>
                            <div className="mt-2">
                                <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-emerald-600 sm:max-w-md">
                                        <input
                                            value={this.state.phone}
                                            onChange={(e) => {if(isNaN(e.target.value)){return}else{this.setState({phone:e.target.value})}}}
                                            id="roleName"
                                            name="roleName"
                                            type="text"
                                            placeholder=""
                                            autoComplete=""
                                            className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm/6"
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <button 
                        disabled={this.state.disabledButton}
                        onClick={() => {this.endItemCreation()}}
                        type="button"
                        className="rounded-md bg-indigo-900 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-900">
                        FINALIZAR
                    </button>
                </div>
                {this.renderNotification()}
            </div>
        )
    }  
}

export default NewCrane;